import { render, staticRenderFns } from "./customer-product.vue?vue&type=template&id=380c8634&scoped=true"
import script from "./customer-product.vue?vue&type=script&lang=js"
export * from "./customer-product.vue?vue&type=script&lang=js"
import style0 from "./customer-product.vue?vue&type=style&index=0&id=380c8634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c8634",
  null
  
)

export default component.exports